import useIdleTimer from "../../hooks/useIdleTimer";
import { runWhenNoCriticalOperation } from "services/criticalOperation";

export const REFRESH_TIME_MS = 30 * 60 * 1000; // 30 minutes

export function useRefreshWhenStale(reload: () => void = () => window.location.reload()) {
  useIdleTimer(REFRESH_TIME_MS, () => {
    runWhenNoCriticalOperation(reload);
  });
}
